export default __webpack_public_path__ + "static/media/fish_afrique.0e53d91d.png";